import {  Component } from '@angular/core'
import { SearchboxComponent } from '../searchbox/searchbox.component'
import { ResearchService } from '../../services/research.service'
import { CommonModule } from '@angular/common'
import { QuestionAndAnswerComponent } from './question-and-answer/question-and-answer.component'
import { TranslocoModule } from '@jsverse/transloco'
import { LoaderComponent } from '../loader/loader.component'
import { MessagehandlerService } from '../../services/messagehandler.service'

@Component({
   selector: 'app-chat',
   standalone: true,
   imports: [CommonModule, SearchboxComponent, QuestionAndAnswerComponent, TranslocoModule, LoaderComponent],
   templateUrl: './chat.component.html',
   // this host adds a 'contents' class, which more or less hides the element from the CSS hierarchy, making the flex box thing work and the searchbox move to the bottom ¯\_(ツ)_/¯
   // eslint-disable-next-line @angular-eslint/no-host-metadata-property
   host: {
      class: 'contents'
   }
})
export class ChatComponent {

   get qandas() {
      return this.research.qandas
   }

   shouldShowLoader = false

   constructor(private research: ResearchService, private messages: MessagehandlerService) {
      // TODO not sure if listening to these messages is a nice way of doing things - probably refactor if we're going to do sessions with observables/signals
      this.messages.appEvents$.subscribe((e) => {
         if (e.event === 'session') {
            if(e.status === 'requesting') {
               this.shouldShowLoader = true
            }
            else {
               this.shouldShowLoader = false
            }
         }

      })
   }
}
